import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Divider, TextInput } from '@/components/ui/daisy';
import { useQuestionExamGradeCtx } from '@/data/context/QuestionExamGradeContext';

type PointsSectionValues = {
  maxGrade?: number;
};

export function PointsSection() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.questionsTab.createQuestionModal.questionForm',
  });
  const gradeCtx = useQuestionExamGradeCtx();
  const {
    register,
    formState: { errors },
  } = useFormContext<PointsSectionValues>();

  if (!gradeCtx) return null;

  const errorMessage = errors?.maxGrade?.message;

  return (
    <>
      <Divider />
      <div className="flex flex-col gap-3">
        <h3 className="text-base font-semibold text-base-content">
          {t('pointsSectionTitle')}
        </h3>
        <TextInput.Fieldset labelAlt={errorMessage}>
          <TextInput.Wrapper>
            <TextInput.Label>{t('points')}</TextInput.Label>
            <TextInput
              type="number"
              placeholder={t('pointsPlaceholder')}
              color={errorMessage ? 'error' : 'default'}
              className="w-32"
              {...register('maxGrade', {
                valueAsNumber: true,
                required: t('pointsRequired'),
                min: { value: 0, message: t('pointsRange') },
                max: { value: 10, message: t('pointsRange') },
              })}
            />
          </TextInput.Wrapper>
        </TextInput.Fieldset>
      </div>
    </>
  );
}
